import type { BaseToolbarProps } from './types';
import { resolveBaseAppearance } from './theme';
import { cn, hasRenderableNode } from './utils';

export function BaseToolbar({
  leading,
  title,
  description,
  actions,
  children,
  appearance,
  className,
  classNames,
  style,
  ...toolbarProps
}: BaseToolbarProps) {
  const theme = resolveBaseAppearance(appearance);
  const hasTitleBlock = hasRenderableNode(title) || hasRenderableNode(description);

  return (
    <div
      {...toolbarProps}
      className={cn(theme.slots.toolbarRoot, classNames?.root, className)}
      style={{
        ...theme.styles.toolbar,
        ...style,
      }}
    >
      <div className={cn(theme.slots.toolbarLeading, classNames?.leading)}>
        {hasRenderableNode(leading) ? leading : null}
        {hasTitleBlock ? (
          <div className={cn(theme.slots.toolbarContent, classNames?.content)}>
            {hasRenderableNode(title) ? (
              <div className={cn(theme.slots.toolbarTitle, classNames?.title)}>
                {title}
              </div>
            ) : null}
            {hasRenderableNode(description) ? (
              <div
                className={cn(
                  theme.slots.toolbarDescription,
                  classNames?.description,
                )}
              >
                {description}
              </div>
            ) : null}
          </div>
        ) : null}
      </div>

      {hasRenderableNode(children) ? (
        <div className={cn(theme.slots.toolbarContent, classNames?.content)}>
          {children}
        </div>
      ) : null}

      {hasRenderableNode(actions) ? (
        <div className={cn(theme.slots.toolbarActions, classNames?.actions)}>
          {actions}
        </div>
      ) : null}
    </div>
  );
}
